import { FC, useCallback, useState } from 'react';
import styled from 'styled-components/native';

import { CheckOutPages } from '../../types/Common';
import CheckoutSection from './CheckoutSection';
import DetailSection from './DetailSection';
import SelectSection from './SelectSection';
import ToggleSection from './ToggleSection';

interface Props {
  disableBtn?: boolean;
  isLoading: boolean;
  onPress: () => void;
  setIsModalOpen?: (v: boolean) => void;
  page?: CheckOutPages;
}

const CheckoutBar: FC<Props> = ({
  isLoading,
  disableBtn,
  page,
  onPress,
  setIsModalOpen,
}) => {
  const [isDetailCollapsed, setIsDetailCollapsed] = useState(true);
  const changeDetailCollapsed = useCallback(() => {
    setIsDetailCollapsed(prevState => !prevState);
  }, []);
  const isCartPage = page === 'cart';

  return (
    <S.Container>
      {isCartPage && (
        <>
          <ToggleSection
            isDetailCollapsed={isDetailCollapsed}
            onPress={changeDetailCollapsed}
          />
          <SelectSection
            isLoading={isLoading}
            setIsModalOpen={setIsModalOpen!}
          />
          {!isDetailCollapsed && <DetailSection />}
        </>
      )}
      <CheckoutSection
        isLoading={isLoading}
        page={page}
        onPress={onPress}
        disableBtn={disableBtn}
      />
    </S.Container>
  );
};

const S = {
  Container: styled.View`
    background-color: ${({ theme }) => theme.palette.white};
  `,
  DetailSection: styled.View`
    padding: 0 15px;
  `,
  SelectSection: styled.View`
    padding: 0 15px;
  `,
  CheckoutSection: styled.View`
    padding-bottom: 35px;
  `,
};

export default CheckoutBar;
